import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetailPayComponent } from './detail-pay.component';
import { DetailPaymentService } from 'src/app/pages/detail-pay/services/detail.payment.service';
import { MaterialModule } from 'src/app/core/material/material.module';

@NgModule({
  declarations: [DetailPayComponent],
  exports: [DetailPayComponent],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: 'detail-pay',
        component: DetailPayComponent,
        data: {
          breadcrumb: 'components.breadcrumb.movements_detail',
          status: true
        }
      }
    ]),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatInputModule,
    TranslateModule.forChild({
      isolate: false
    })
  ]
  // providers: [DetailPaymentService]
})
export class DetailPayModule {}
